export default "__VITE_ASSET__5md$z3VD__"